export default __webpack_public_path__ + "static/media/plus.e24d097f.svg";